"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _collapseTransition = _interopRequireDefault(require("@/utils/collapse-transition"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    collapseTransition: _collapseTransition.default
  },
  props: {
    filter_form: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    device: function device() {
      return this.$store.state.app.device;
    }
  },
  data: function data() {
    return {
      drawer: true,
      opa: true,
      moreFilterHeight: 0
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.setMore();
    if (document.body.clientWidth >= 768) {
      window.addEventListener('resize', function () {
        _this.drawer = true;
        _this.opa = true;
        setTimeout(function () {
          _this.setMore();
        }, 500);
      });
    }
  },
  methods: {
    /**
     * 设置筛选更多是否显示
     */
    setMore: function setMore() {
      var _this2 = this;
      if (!this.$refs.moreFilter) return;
      this.moreFilterHeight = this.$refs.moreFilter.offsetHeight;
      this.drawer = false;
      setTimeout(function () {
        _this2.opa = false;
      }, 500);
    },
    /**
     * 隐藏更多
     */
    hide: function hide() {
      this.drawer = false;
    }
  }
};